let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("289s7")).then(() => parcelRequire('50CQu'));